/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import { Fragment } from 'react';
import * as dc from '@/lib/dc';
import type { ViewModel } from './view-model';

export function WidgetsView({ m }: { m: ViewModel }) {
  return (
    <div style={{ padding: '16px 12px 28px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
      {' '}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {' '}
        <i className="ph ph-squares-four" style={{ color: 'var(--acc-fill)', fontSize: '16px' }}></i>{' '}
        <span style={{ fontSize: '13.5px', fontWeight: '500' }}>My Dashboard</span>{' '}
        <div style={{ flex: '1' }}></div>{' '}
        <button
          onClick={m.dashEdit}
          aria-label="Edit which widgets show on the dashboard"
          className="scp-50560d1"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            fontSize: '11.5px',
            padding: '6px 13px',
            borderRadius: '99px',
            border: '1px solid color-mix(in srgb, var(--acc-fill) 45%, transparent)',
            background: 'transparent',
            color: 'var(--acc)',
            cursor: 'pointer',
          }}
        >
          <i className="ph ph-pencil-simple" style={{ fontSize: '12px' }}></i>Edit Dashboard
        </button>{' '}
      </div>{' '}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '2fr 1fr 1fr',
          gridTemplateRows: 'auto auto',
          gap: '12px',
        }}
      >
        {' '}
        {m.dashShow?.('equity') === false ? null : (
          <div
            style={{
              gridRow: 'span 2',
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '16px 18px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {' '}
            <div
              style={{
                fontSize: '9.5px',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
              }}
            >
              Equity curve
            </div>{' '}
            <svg
              viewBox="0 0 640 280"
              style={{ width: '100%', flex: '1', marginTop: '10px', minHeight: '220px' }}
              preserveAspectRatio="none"
            >
              {' '}
              <g stroke="var(--l8)">
                <line x1="0" y1="65" x2="640" y2="65"></line>
                <line x1="0" y1="130" x2="640" y2="130"></line>
                <line x1="0" y1="195" x2="640" y2="195"></line>
              </g>{' '}
              <defs>
                <linearGradient id="wqg" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0" stopColor="var(--pos)" stopOpacity="0.13"></stop>
                  <stop offset="1" stopColor="var(--pos)" stopOpacity="0"></stop>
                </linearGradient>
              </defs>{' '}
              <path
                d="M0,258 C60,252 90,238 130,224 C170,210 200,196 250,184 C300,172 330,166 380,150 C430,134 460,124 510,102 C560,80 600,58 640,34 L640,280 L0,280 Z"
                fill="url(#wqg)"
              ></path>{' '}
              <path
                d="M0,258 C60,252 90,238 130,224 C170,210 200,196 250,184 C300,172 330,166 380,150 C430,134 460,124 510,102 C560,80 600,58 640,34"
                fill="none"
                stroke="var(--pos)"
                strokeWidth="2"
              ></path>{' '}
              <line x1="0" y1="262" x2="640" y2="262" stroke="var(--l8)" strokeDasharray="4 5"></line>{' '}
            </svg>{' '}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                fontSize: '10px',
                color: 'var(--muted)',
                marginTop: '6px',
              }}
            >
              <span>Jul 22</span>
              <span>Jul 23</span>
              <span>Jul 24</span>
            </div>{' '}
          </div>
        )}{' '}
        {m.dashShow?.('drawdown') === false ? null : (
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '16px 18px',
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              gap: '6px',
              minHeight: '130px',
            }}
          >
            {' '}
            <div
              style={{
                fontSize: '9.5px',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
                textAlign: 'left',
              }}
            >
              Current drawdown
            </div>{' '}
            <i className="ph ph-trend-down" style={{ fontSize: '20px', color: 'var(--pos)' }}></i>{' '}
            <div style={{ fontSize: '21px', fontWeight: '600', fontVariantNumeric: 'tabular-nums' }}>
              −$0.00
            </div>{' '}
            <div style={{ fontSize: '10.5px', color: 'var(--muted2)' }}>Max Drawdown</div>{' '}
          </div>
        )}{' '}
        {m.dashShow?.('winrate') === false ? null : (
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '16px 18px',
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              gap: '6px',
              minHeight: '130px',
            }}
          >
            {' '}
            <div
              style={{
                fontSize: '9.5px',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
                textAlign: 'left',
              }}
            >
              Win rate
            </div>{' '}
            <i className="ph ph-target" style={{ fontSize: '20px', color: 'var(--pos)' }}></i>{' '}
            <div style={{ fontSize: '21px', fontWeight: '600', fontVariantNumeric: 'tabular-nums' }}>
              100.0%
            </div>{' '}
            <div style={{ fontSize: '10.5px', color: 'var(--muted2)' }}>Win Rate</div>{' '}
          </div>
        )}{' '}
        {m.dashShow?.('profitfactor') === false ? null : (
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '16px 18px',
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              gap: '6px',
              minHeight: '130px',
            }}
          >
            {' '}
            <div
              style={{
                fontSize: '9.5px',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
                textAlign: 'left',
              }}
            >
              Profit factor
            </div>{' '}
            <i className="ph ph-trend-up" style={{ fontSize: '20px', color: 'var(--pos)' }}></i>{' '}
            <div style={{ fontSize: '21px', fontWeight: '600', fontVariantNumeric: 'tabular-nums' }}>∞</div>{' '}
            <div style={{ fontSize: '10.5px', color: 'var(--muted2)' }}>No losing trades</div>{' '}
          </div>
        )}{' '}
        {m.dashShow?.('expectancy') === false ? null : (
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '16px 18px',
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              gap: '6px',
              minHeight: '130px',
            }}
          >
            {' '}
            <div
              style={{
                fontSize: '9.5px',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
                textAlign: 'left',
              }}
            >
              Expectancy
            </div>{' '}
            <i className="ph ph-lightning" style={{ fontSize: '20px', color: 'var(--acc)' }}></i>{' '}
            <div style={{ fontSize: '21px', fontWeight: '600', fontVariantNumeric: 'tabular-nums' }}>
              $2,511.29
            </div>{' '}
            <div style={{ fontSize: '10.5px', color: 'var(--muted2)' }}>Avg P&L per Trade</div>{' '}
          </div>
        )}{' '}
      </div>{' '}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px' }}>
        {' '}
        {m.dashShow?.('daily') === false ? null : (
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '16px 18px',
              display: 'flex',
              flexDirection: 'column',
              minHeight: '240px',
            }}
          >
            {' '}
            <div
              style={{
                fontSize: '9.5px',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
              }}
            >
              Daily performance
            </div>{' '}
            <div
              style={{
                flex: '1',
                display: 'flex',
                alignItems: 'flex-end',
                gap: '22px',
                padding: '16px 14px 0',
              }}
            >
              {' '}
              <div
                style={{
                  flex: '1',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '6px',
                  height: '100%',
                  justifyContent: 'flex-end',
                }}
              >
                <div
                  style={{
                    width: '100%',
                    maxWidth: '60px',
                    height: '96%',
                    borderRadius: '6px 6px 3px 3px',
                    background:
                      'linear-gradient(180deg,var(--pos),color-mix(in srgb, var(--pos) 45%, transparent))',
                  }}
                ></div>
              </div>{' '}
              <div
                style={{
                  flex: '1',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '6px',
                  height: '100%',
                  justifyContent: 'flex-end',
                }}
              >
                <div
                  style={{
                    width: '100%',
                    maxWidth: '60px',
                    height: '89%',
                    borderRadius: '6px 6px 3px 3px',
                    background:
                      'linear-gradient(180deg,var(--pos),color-mix(in srgb, var(--pos) 45%, transparent))',
                  }}
                ></div>
              </div>{' '}
              <div
                style={{
                  flex: '1',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '6px',
                  height: '100%',
                  justifyContent: 'flex-end',
                }}
              >
                <div
                  style={{
                    width: '100%',
                    maxWidth: '60px',
                    height: '66%',
                    borderRadius: '6px 6px 3px 3px',
                    background:
                      'linear-gradient(180deg,var(--pos),color-mix(in srgb, var(--pos) 45%, transparent))',
                  }}
                ></div>
              </div>{' '}
            </div>{' '}
            <div style={{ display: 'flex', gap: '22px', padding: '8px 14px 0' }}>
              <span style={{ flex: '1', textAlign: 'center', fontSize: '10px', color: 'var(--muted)' }}>
                Jul 24
              </span>
              <span style={{ flex: '1', textAlign: 'center', fontSize: '10px', color: 'var(--muted)' }}>
                Jul 23
              </span>
              <span style={{ flex: '1', textAlign: 'center', fontSize: '10px', color: 'var(--muted)' }}>
                Jul 22
              </span>
            </div>{' '}
          </div>
        )}{' '}
        {m.dashShow?.('rmulti') === false ? null : (
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '16px 18px',
              display: 'flex',
              flexDirection: 'column',
              minHeight: '240px',
            }}
          >
            {' '}
            <div
              style={{
                fontSize: '9.5px',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
              }}
            >
              R multiple distribution
            </div>{' '}
            <div
              style={{
                flex: '1',
                display: 'flex',
                alignItems: 'flex-end',
                gap: '10px',
                padding: '16px 8px 0',
              }}
            >
              {' '}
              <div style={{ flex: '1', height: '100%', display: 'flex', alignItems: 'flex-end' }}>
                <div
                  style={{ width: '100%', height: '2%', borderRadius: '4px', background: 'var(--l10)' }}
                ></div>
              </div>{' '}
              <div style={{ flex: '1', height: '100%', display: 'flex', alignItems: 'flex-end' }}>
                <div
                  style={{ width: '100%', height: '2%', borderRadius: '4px', background: 'var(--l10)' }}
                ></div>
              </div>{' '}
              <div style={{ flex: '1', height: '100%', display: 'flex', alignItems: 'flex-end' }}>
                <div
                  style={{ width: '100%', height: '2%', borderRadius: '4px', background: 'var(--l10)' }}
                ></div>
              </div>{' '}
              <div style={{ flex: '1', height: '100%', display: 'flex', alignItems: 'flex-end' }}>
                <div
                  style={{
                    width: '100%',
                    height: '88%',
                    borderRadius: '6px 6px 3px 3px',
                    background: 'linear-gradient(180deg,var(--acc-fill),var(--l8))',
                  }}
                ></div>
              </div>{' '}
              <div style={{ flex: '1', height: '100%', display: 'flex', alignItems: 'flex-end' }}>
                <div
                  style={{
                    width: '100%',
                    height: '14%',
                    borderRadius: '4px',
                    background: 'linear-gradient(180deg,var(--acc-fill),var(--l8))',
                  }}
                ></div>
              </div>{' '}
              <div style={{ flex: '1', height: '100%', display: 'flex', alignItems: 'flex-end' }}>
                <div
                  style={{ width: '100%', height: '2%', borderRadius: '4px', background: 'var(--l10)' }}
                ></div>
              </div>{' '}
            </div>{' '}
            <div style={{ display: 'flex', gap: '10px', padding: '8px 8px 0' }}>
              <span style={{ flex: '1', textAlign: 'center', fontSize: '9px', color: 'var(--faint)' }}>
                {'< −2R'}
              </span>
              <span style={{ flex: '1', textAlign: 'center', fontSize: '9px', color: 'var(--faint)' }}>
                −2R…−1R
              </span>
              <span style={{ flex: '1', textAlign: 'center', fontSize: '9px', color: 'var(--faint)' }}>
                −1R…0
              </span>
              <span style={{ flex: '1', textAlign: 'center', fontSize: '9px', color: 'var(--faint)' }}>
                0…1R
              </span>
              <span style={{ flex: '1', textAlign: 'center', fontSize: '9px', color: 'var(--faint)' }}>
                1R…2R
              </span>
              <span style={{ flex: '1', textAlign: 'center', fontSize: '9px', color: 'var(--faint)' }}>
                {'> 2R'}
              </span>
            </div>{' '}
          </div>
        )}{' '}
        {m.dashShow?.('dayweek') === false ? null : (
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '16px 18px',
              display: 'flex',
              flexDirection: 'column',
              minHeight: '240px',
            }}
          >
            {' '}
            <div
              style={{
                fontSize: '9.5px',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
              }}
            >
              Day of week performance
            </div>{' '}
            <div
              style={{
                flex: '1',
                display: 'flex',
                alignItems: 'flex-end',
                gap: '10px',
                padding: '16px 8px 0',
              }}
            >
              {' '}
              <div style={{ flex: '1', height: '100%', display: 'flex', alignItems: 'flex-end' }}>
                <div
                  style={{ width: '100%', height: '2%', borderRadius: '4px', background: 'var(--l10)' }}
                ></div>
              </div>{' '}
              <div style={{ flex: '1', height: '100%', display: 'flex', alignItems: 'flex-end' }}>
                <div
                  style={{ width: '100%', height: '2%', borderRadius: '4px', background: 'var(--l10)' }}
                ></div>
              </div>{' '}
              <div style={{ flex: '1', height: '100%', display: 'flex', alignItems: 'flex-end' }}>
                <div
                  style={{ width: '100%', height: '2%', borderRadius: '4px', background: 'var(--l10)' }}
                ></div>
              </div>{' '}
              <div style={{ flex: '1', height: '100%', display: 'flex', alignItems: 'flex-end' }}>
                <div
                  style={{
                    width: '100%',
                    height: '66%',
                    borderRadius: '6px 6px 3px 3px',
                    background:
                      'linear-gradient(180deg,var(--pos),color-mix(in srgb, var(--pos) 45%, transparent))',
                  }}
                ></div>
              </div>{' '}
              <div style={{ flex: '1', height: '100%', display: 'flex', alignItems: 'flex-end' }}>
                <div
                  style={{
                    width: '100%',
                    height: '89%',
                    borderRadius: '6px 6px 3px 3px',
                    background:
                      'linear-gradient(180deg,var(--pos),color-mix(in srgb, var(--pos) 45%, transparent))',
                  }}
                ></div>
              </div>{' '}
              <div style={{ flex: '1', height: '100%', display: 'flex', alignItems: 'flex-end' }}>
                <div
                  style={{
                    width: '100%',
                    height: '96%',
                    borderRadius: '6px 6px 3px 3px',
                    background:
                      'linear-gradient(180deg,var(--pos),color-mix(in srgb, var(--pos) 45%, transparent))',
                  }}
                ></div>
              </div>{' '}
              <div style={{ flex: '1', height: '100%', display: 'flex', alignItems: 'flex-end' }}>
                <div
                  style={{ width: '100%', height: '2%', borderRadius: '4px', background: 'var(--l10)' }}
                ></div>
              </div>{' '}
            </div>{' '}
            <div style={{ display: 'flex', gap: '10px', padding: '8px 8px 0' }}>
              <span style={{ flex: '1', textAlign: 'center', fontSize: '9px', color: 'var(--faint)' }}>
                Sun
              </span>
              <span style={{ flex: '1', textAlign: 'center', fontSize: '9px', color: 'var(--faint)' }}>
                Mon
              </span>
              <span style={{ flex: '1', textAlign: 'center', fontSize: '9px', color: 'var(--faint)' }}>
                Tue
              </span>
              <span style={{ flex: '1', textAlign: 'center', fontSize: '9px', color: 'var(--faint)' }}>
                Wed
              </span>
              <span style={{ flex: '1', textAlign: 'center', fontSize: '9px', color: 'var(--faint)' }}>
                Thu
              </span>
              <span style={{ flex: '1', textAlign: 'center', fontSize: '9px', color: 'var(--faint)' }}>
                Fri
              </span>
              <span style={{ flex: '1', textAlign: 'center', fontSize: '9px', color: 'var(--faint)' }}>
                Sat
              </span>
            </div>{' '}
          </div>
        )}{' '}
      </div>{' '}
      {m.dashShow?.('history') === false ? null : (
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '16px 18px',
          }}
        >
          {' '}
          <div
            style={{
              fontSize: '9.5px',
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
              marginBottom: '8px',
            }}
          >
            Trade history
          </div>{' '}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1.4fr 1fr 1fr 1fr',
              fontSize: '10px',
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: 'var(--faint)',
              padding: '6px 8px',
              borderBottom: '1px solid var(--l8)',
            }}
          >
            <span>Symbol</span>
            <span>Dir</span>
            <span style={{ textAlign: 'right' }}>P&L</span>
            <span style={{ textAlign: 'right' }}>Duration</span>
          </div>{' '}
          {(m.trades ?? []).map((t, i27) => (
            <Fragment key={i27}>
              {' '}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1.4fr 1fr 1fr 1fr',
                  alignItems: 'center',
                  fontSize: '12px',
                  padding: '8px',
                  borderBottom: '1px solid var(--l5)',
                }}
              >
                {' '}
                <span style={{ fontWeight: '500' }}>
                  {'XAUUSD '}
                  <span style={{ color: 'var(--faint)', fontWeight: '400', fontSize: '10.5px' }}>
                    {'· '}
                    {dc.t(t?.date)}
                  </span>
                </span>{' '}
                <span>
                  <span
                    style={dc.css(
                      `font-size:9.5px;font-weight:600;letter-spacing:0.06em;padding:2px 8px;border-radius:99px;background:${dc.s(t?.sideBg)};color:${dc.s(t?.sideFg)}`,
                    )}
                  >
                    {dc.t(t?.side)}
                  </span>
                </span>{' '}
                <span style={{ textAlign: 'right', color: 'var(--pos)', fontVariantNumeric: 'tabular-nums' }}>
                  {dc.t(t?.pnl)}
                </span>{' '}
                <span
                  style={{ textAlign: 'right', color: 'var(--muted2)', fontVariantNumeric: 'tabular-nums' }}
                >
                  {dc.t(t?.dur)}
                </span>{' '}
              </div>{' '}
            </Fragment>
          ))}{' '}
        </div>
      )}
    </div>
  );
}
